import template from './component.tpl.html';
import SchuetzenfestzeltDashboardController from './controller';

angular
    .module('festzelt-os.dashboard')
    .component('dashboardSchuetzenfestzelt', {
        bindings: {

        },
        controller: SchuetzenfestzeltDashboardController,
        controllerAs: 'vm',
        templateUrl: template
    });




// WEBPACK FOOTER //
// ./src/app/pages/dashboard/components/schuetzenfestzelt-dashboard/component.js